module.exports = __webpack_public_path__ + "static/img/hamilton1.999627f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/hamilton1.jpg
// module id = 96
// module chunks = 9